import React from "react";
import PropTypes from "prop-types";

const PageHeader = ({ title, children, className = "" }) => {
  return (
    <div className={`list-page-header ${className}`.trim()}>
      <h1 className="page-title">{title}</h1>
      {children ? <div className="list-page-header__actions">{children}</div> : null}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PageHeader;
